<template>
  <v-row justify="center">
    <v-col cols="12" align="center">
      <div class="footer__title">{{ $t('footer.partners') }}</div>

      <v-row justify="center">
        <v-col
          v-for="(partner, index) in partners"
          :key="index"
          sm="2"
          cols="4"
        >
          <a
            :href="partner.link[locale]"
            target="_blank"
          >
            <v-img
              :src="partner.logo"
            />
          </a>
        </v-col>

        <v-col
          cols="12"
        >
          <v-btn
            outlined
            color="#fff"
            class="rounded-0"
            :href="`https://www.lausanne-tourisme.ch/${locale}/partners/`"
            target="_blank"
          >
            {{ $t('footer.all-partners') }}
          </v-btn>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
  export default {
    name: 'TheFooterPartners',

    computed: {
      locale() {
        return this.$store.state.locale
      }
    },

    data() {
      return {
        partners: [
          {
            link: {
              fr: 'https://www.lausanne.ch/',
              en: 'https://www.lausanne.ch/',
              de: 'https://www.lausanne.ch/',
            },
            logo: require('@/assets/logos/villelogo.svg')
          },
          {
            link: {
              fr: 'https://www.region-du-leman.ch/fr',
              en: 'https://www.region-du-leman.ch/en',
              de: 'https://www.region-du-leman.ch/de',
            },
            logo: require('@/assets/logos/vaudlogo.svg')
          },
          {
            link: {
              fr: 'https://www.lausanne-montreux-congress.ch/fr',
              en: 'https://www.lausanne-montreux-congress.ch/en',
              de: 'https://www.lausanne-montreux-congress.ch/en',
            },
            logo: require('@/assets/logos/lmc.svg')
          },
          {
            link: {
              fr: 'https://www.myswitzerland.com',
              en: 'https://www.myswitzerland.com/en',
              de: 'https://www.myswitzerland.com/de-ch',
            },
            logo: require('@/assets/logos/st.svg')
          },
          {
            link: {
              fr: 'https://www.tgv-lyria.com/fr/fr',
              en: 'https://www.tgv-lyria.com/fr/en',
              de: 'https://www.tgv-lyria.com/fr/de',
            },
            logo: require('@/assets/logos/lyria.svg')
          },
        ]
      }
    }
  }
</script>

<style lang="sass" scoped>
  .v-responsive
    min-height: 70px
  .v-btn
    margin-top: 15px
</style>
